import React, {Component} from 'react';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';
import { Link } from 'react-router-dom'
import heroBG from '../media/homebackground.JPG' //'../media/homebackground.JPG' // '../media/holiday_winterTreeBGCropped.jpg'
import cows1 from '../media/MaryLeeBDay1.jpg'
import cows2 from '../media/MaryLeeBDay2.jpg'

const HeroSection = (props) => ( 
  <FluidContainer fluid>
    <InternalContainer>
      <h1>Patterson Farms</h1>
      <h1>Makers of Pure Maple Products</h1>
      <h3>Proud 4th generation sugarmasters</h3>


	  {/**
	  <NoteP>
	  		 Unfortunately, due to keeping our families safe right now, we are closing our walk in retail store effective immediately.&nbsp;  
	  		 <u>HERE (OUR WEBSITE) & OUR OFFICE remain open</u> and orders can be placed by calling <a href="tel:814-628-3751">814-628-3751</a>&nbsp;
	  		 for curbside or shipping orders or by ordering here on the website to have them shipped too. 
	  		 Our family lives here & can provide curbside services to anyone in the area. 
	  		 We can finalize orders, payment & pickup arrangements at the time you place your order. 
	  		 Thank you for understanding during this crisis. Stay safe! ❤️
	  </NoteP>
	  */}
	  {/*
	  <NoteP>
			Our walk in retail store is now back open, effective May 1st. Please feel free to stop in, and stay safe!
	  </NoteP> 
	  */ }


	  
      {/*<HeroImg src={require("../media/silo_hero_collage.jpg")}></HeroImg>*/}
      {/*<HeroImg src={require("../media/sugarhouse_05142022.jpg")}></HeroImg>*/}
      <HeroImg src={require("../media/sugarhouse_07232023.jpg")}></HeroImg>
      {/*
		<NoteP>
		    <h1>Black Friday Sale!</h1>
		    <p>Patterson Farms is offering 10% off all products this Friday "Black Friday" & Saturday "Small Business Saturday"! This sale is available
		    both days by <u><b>visiting the store or calling in an order</b></u>. Visit our store in person & you will be entered in a drawing for a FREE holiday basket!

		    We are closed for Thanksgiving and open our regular hours on Friday 10-5 & Saturday 9-3.
			</p>
		</NoteP>
	*/}
      {/*
      <NoteP>Wishing the matriarch of the Patterson Farms Family, Aunt Mary Lee Zechman - a happy 85th Birthday!!!</NoteP>
      	 <CowPics>
		 	<CowPic src={cows1}></CowPic>
		 	<CowPic2 src={cows2}></CowPic2>
	     </CowPics>
	   */}


      {/*  removed 9.25.21
      <LindaP>
      	Together, Terri & Terry Patterson took over ownership as the 4th generation sugar makers of Patterson Farms 
      	in Sabinsville, Pennsylvania. Terry's father, Richard, passed away in 2017. Richard would be proud to see
      	them keeping his legacy alive by accomplishing plans he had for the farm before he passed, as well as
      	bringing some of their own ideas to the business. Patterson Farms is the largest producer in Pennsylvania,
      	and boasts over 80,000 taps! To maximize efficiency, they recently purchased three 12' x 20' CDL Stainless Steel Sap Silos.
	  </LindaP>
	  <LindaP>
      	The silos can be fed from top or bottom. The bottom is sloped for full drainage, and is equipped with a washing system.
      	Each silo can hold 17,000 gallons. Trucks will unload sap into the first silo, where it will then run through a sand filter into the second silo.
      	Filtering the sap before it runs through the RO will prolong the life of their membranes and prefilters. The third silo will 
      	hold permeate from the RO for cleaning.
      </LindaP>
  		*/ }
      {/*
      <LindaP>
      	<h4>Effective 4/28/21, please notice our increased gallon (+$4) and half gallon (+$2) syrup prices. Thank you for your understanding.</h4>
      </LindaP>
	  */}

	   {/*
      <NoteP>
      	Older styled (original logo) t-shirts & denim shirts are for sale on a 20% discount! Select sizes available, so get them while you can!
      </NoteP>
      */}


      {/**
      <LindaP>
			Linda Neal, one of the main faces of Patterson Farms for the last 29 years, retired on June 5th. 
			Linda started with us in 1991. Linda has worked side by side over the years with Richard,
			Mary Lee, Todd, Tim & many others developing the maple industry in this area & making 
			Patterson Farms what it is today. Since the passing of Richard in 2017, 
			she has stayed on to teach us 'newbies' the ropes & share her wisdom/knowledge. 
			We value those words of wisdom/knowledge & have enjoyed being mentored by her the last 1 1/2 years. 
			We most importantly value her friendship & will miss her so much. <br/><br/>
			Linda will still be around the Sugarhouse though! 
			She has promised to help us with our tours, open house & most importantly our sugaring season. 
			In the meantime, she is going to take some much deserved time off & travel out West to pan for gold! 
			We are so excited for her to transition into this next phase of lifel We love Linda & want her to 
			know she is still a part of our family & expect her to visit a lot & keep us in line! 
			<b> We love you Linda & wish you a 'Happy Retirement'!!</b>
      </LindaP>
  	 */}
      <ShopNowLink to="/Shop">
      	<ShopNowDiv>
	      	<ShopNowBucket src={require("../media/shopBucket.png")}></ShopNowBucket>
	      	<ShopNowBucketLeaves_Img src={require("../media/leavespng2.png")}></ShopNowBucketLeaves_Img>
      	</ShopNowDiv>
      </ShopNowLink>
    </InternalContainer>
  </FluidContainer>
);

const CowPics = styled(Col)`
	margin-bottom: 10px;
`;
const CowPic = styled.img`
	height: 410px;
	width: 100%;
	margin: 0 auto;
	border: 1px solid sandybrown;

	${media.sm` `}
	${media.md` width: 45%; height:530px;`}
	${media.lg` width: 40%; `}
	${media.xl` width: 35%; `}
	${media.xxl` `}
`;

const CowPic2 = styled.img`
	height: 410px;
	width: 100%;
	margin: 0 auto;
	border: 1px solid sandybrown;

	${media.sm` `}
	${media.md` width: 45%; height:530px;`}
	${media.lg` width: 40%; `}
	${media.xl` width: 35%; `}
	${media.xxl` `}
`;

const LindaP = styled.p`
	text-align: left;
`

const NoteP = styled.p`
	/* AFTER HOLIDAY THEMING - GO BACK TO WHITE */
	color: black;
	font-weight: bold;
	
`

const HeroImg = styled.img`
	width: 100%;
	height: auto;
	margin: 0 auto;
	margin-bottom: 20px;
	display: block;

	// 70px top
	${media.lg`
		max-height: calc(100vh - 70px - 120px - 210px);
		width: 80%;
	`}
	${media.xl`
		max-height: calc(100vh - 70px - 140px - 210px);
		width: 65%;
	`}
	${media.xxl`
		max-height: calc(100vh - 70px - 100px - 220px);
		width: 90%;
	`}
`;

const ShopNowLink = styled(Link)`
	transition: all 0.5s;
  	:hover { transform: translateY(6px); }
  	display: inline-flex;
`;

const ShopNowDiv = styled.div` margin: 0 0 15px 0; `;

const ShopNowBucket = styled.img`
	width: 90px!important;
	height: 90px!important;

	${media.md`
		width: 100px!important;
		height: 100px!important;
	`}
	${media.lg`
		width: 125px!important;
		height: 125px!important;
	`}
	${media.xl`
		width: 130px!important;
		height: 130px!important;
	`}
	${media.xxl`
		width: 150px!important;
		height: 150px!important;
	`}
`;

const ShopNowBucketLeaves_Img = styled.img`
	width: 60px!important;
	height: 50px!important;
	position: absolute;
	margin: 35px 0 0 -30px;

	${media.md`
		width: 70px!important;
		height: 60px!important;
	`}
	${media.lg`
		width: 85px!important;
		height: 72px!important;
		margin: 45px 0 0 -40px;
	`}
	${media.xl`
		width: 90px!important;
		height: 75px!important;
		margin: 50px 0 0 -45px;
	`}
	${media.xxl`
		width: 95px!important;
		height: 80px!important;
		margin: 58px 0 0 -50px;
	`}
`;


const FluidContainer = styled(Container)`
	background-image: url(${heroBG}); 
	text-align: center;
	padding: 30px 0 0 0!important;
	

	h1 {
		color: black!important;
	}
	h3 {
		color: black!important;

	}
`;

const InternalContainer = styled(Container)`  `;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
  display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/

export default HeroSection;


// WEBPACK FOOTER //
// ./src/components/HeroSection.js